import { apiUrl } from '../config';
import { fetch } from '../utils/http';

export function fetchTerritoriesStart() {
    return {
        type : 'TERRITORIES_FETCH_START',
    }
}

export function fetchTerritoriesSuccess(data) {
    return {
        type : 'TERRITORIES_FETCH_SUCCESS',
        data
    }
}

export function fetchTerritoriesFailure(error) {
    return {
        type : 'TERRITORIES_FETCH_FAILURE',
        error
    }
}

export function fetchTerritories(page) {
    return function(dispatch) {
        dispatch(fetchTerritoriesStart());
        const url = `${apiUrl()}/territories`;
        fetch(url)
            .then(response => response.json())
            .then(json => dispatch(fetchTerritoriesSuccess(json)))
            .catch(error => dispatch(fetchTerritoriesFailure(error)))
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/territories.js
 **/